import { render, staticRenderFns } from "./ewmPucha.vue?vue&type=template&id=1d73dd96&scoped=true&"
import script from "./ewmPucha.vue?vue&type=script&lang=js&"
export * from "./ewmPucha.vue?vue&type=script&lang=js&"
import style0 from "./ewmPucha.vue?vue&type=style&index=0&id=1d73dd96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d73dd96",
  null
  
)

export default component.exports